import React from 'react';
import { ShareExperienceSignIn } from 'components/layout/forms';
import { PageWrapper2 } from 'components/modules/Wrapper2';
// import { home } from 'assets/images';
function ShareExperienceSignInView() {
	return (
		<div className='bg-[#0E1022]'>
			<PageWrapper2>
				<div>
					<ShareExperienceSignIn />
				</div>
			</PageWrapper2>
		</div>
	);
}

export default ShareExperienceSignInView;
